import React from "react"
import { Grid } from "@material-ui/core"

import Routes from "@/routes"

console.log("Letalk: Inbox-CP (React v17.0.0)")

const App = () => {
	return (
		<Grid
			container
			justify="center"
		>
			<Routes />
		</Grid>
	)
}

export default App
